import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
//options we support in our toolbar
var richTextToolbar = {
  HEADER: 'header',
  SIZE: 'size',
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKE: 'strike',
  ORDERED_LIST: 'ordered',
  BULLET_LIST: 'bullet',
  SUB_SCRIPT: 'sub',
  SUPER_SCRIPT: 'super',
  ALIGN: 'align',
  COLOR: 'color',
  BACKGROUND_COLOR: 'background',
  LINK: 'link',
  CLEAN: 'clean'
}; //full list of rich text formatting options

richTextToolbar.ALL = _valuesInstanceProperty(_).call(_, richTextToolbar); //defines a basic list of formatting options. However, the dev is free to build his own list, this is just for 'help'

richTextToolbar.BASIC = [richTextToolbar.BOLD, richTextToolbar.ITALIC, richTextToolbar.UNDERLINE, richTextToolbar.COLOR, richTextToolbar.BACKGROUND_COLOR, richTextToolbar.LINK, richTextToolbar.CLEAN];
export default richTextToolbar;
//# sourceMappingURL=richtext-toolbar.js.map